// src/shared/hooks/useAlert.js
import { useState, useCallback } from 'react';

export const useAlert = (initialState = { show: false, variant: '', message: '' }) => {
    const [alert, setAlert] = useState(initialState);
    const [showAlert, setShowAlert] = useState(false);

    const showSuccess = useCallback((message) => {
        setAlert({ show: true, variant: 'success', message });
        setShowAlert(true);
    }, []);

    const showError = useCallback((message) => {
        setAlert({ show: true, variant: 'danger', message });
        setShowAlert(true);
    }, []);

    const hideAlert = useCallback(() => {
        setShowAlert(false);
    }, []);

    return {
        alert,
        showAlert,
        showSuccess,
        showError,
        hideAlert
    };
};